exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".choose{background-color:var(--c2)!important}.error{color:red;border:1px solid red;width:40%;padding:2px 2px 2px 26px;border-radius:6px;background-color:#faebd7}td{cursor:pointer}.student_modal{position:absolute;top:20%;background-color:#faebd7;padding:10px;width:664px;height:401px;border:1px solid #000;border-radius:13px}", ""]);

// exports
